import React from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export default function GradeSelector({
  currentValue,
  onChange,
}: {
  currentValue: number
  onChange: (g: number) => void
}) {
  const grades = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  const gradeTags = [
    'K',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
  ]

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="grade-selector-label">Grade</InputLabel>
        <Select
          defaultValue={currentValue}
          onChange={(e) => onChange(e.target.value as number)}
          value={currentValue}
          id="grade-selector"
          data-testid="grade-selector"
        >
          {grades.map((grade, index) => (
            <MenuItem key={`grade-selector-${grade}`} value={grade}>
              Grade {gradeTags[index]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
